(() => {
  angular
    .module('app')
    .controller('host.views.hospitalizationExclusions.exclusionEditor', ExclusionEditorController);

  ExclusionEditorController.$inject = [
    '$stateParams',
    '$scope',
    '$timeout',
    '$state',
    'abp.services.app.hospitalizationExclusion',
    'moment',
    'Hms.Services.ServiceType'
  ];

  function ExclusionEditorController(
    $stateParams,
    $scope,
    $timeout,
    $state,
    hospitalizationExclusionSvc,
    moment,
    enumServiceType
  ) {
    const vm = this;
    vm.loading = 0;
    vm.saving = 0;
    vm.isEditing = false;
    vm.serviceType = $stateParams.serviceType;
    vm.accountOwnerId = $stateParams.accountOwnerId;
    vm.data = null;
    vm.exclusionsForDelete = [];
    vm.enums = {};

    vm.enums = {
      serviceType: enumServiceType,
    };

    vm.permissions = {
      exclusionListEdit: abp.auth.isGranted('Host.Treatments.ExclusionList.Edit'),
    };

    vm.saveAll = saveAll;
    vm.validateForm = validateForm;
    vm.isDirty = isDirty;
    vm.toggleEdit = toggleEdit;
    vm.getExclusions = getExclusions();
    vm.cancel = cancel;
    vm.addExclusion = addExclusion;
    vm.getExclusionList = getExclusionList;
    vm.remove = remove;

    init();

    function init() {
      getExclusions();
    }

    // Save all changes on the form.

    function saveAll() {
      if (vm.saving || vm.loading) return;

      if (!vm.validateForm()) {
        abp.notify.error(App.localize('GeneralInvalidFormInputError'));
        return;
      }
      createOrUpdateExclusions();

      if (vm.exclusionsForDelete.length) {
        deleteSelectedExclusions(vm.exclusionsForDelete);
      }
    }

    function validateForm() {
      const form = $scope.exclusionClausesEditorForm;
      App.touchFormErrors(form);
      return form.$valid;
    }

    function isDirty() {
      return $scope.exclusionClausesEditorForm && $scope.exclusionClausesEditorForm.$dirty;
    }

    function toggleEdit(flag) {
      vm.isEditing = flag;
    }

    // Get exclusions.

    function getExclusions() {
      vm.loading += 1;
      hospitalizationExclusionSvc
        .getServiceExclusionsForEdit({
          serviceType: vm.serviceType,
          accountOwnerId: vm.accountOwnerId,
        })
        .success((record) => {
          vm.data = record;
          vm.data.defaultExclusions = vm.data.defaultExclusions || [];
          vm.data.optionalExclusions = vm.data.optionalExclusions || [];
          vm.data.iglImportantNotes = vm.data.iglImportantNotes || [];
          vm.data.addonImportantNotes = vm.data.addonImportantNotes || [];
          vm.data.policyImportantNotes = vm.data.policyImportantNotes || [];
          vm.data.fglImportantNotes = vm.data.fglImportantNotes || [];
        })
        .finally(() => {
          vm.loading -= 1;
        });
    }

    // Create or update exclusions.

    function createOrUpdateExclusions() {
      const lists = _.unionWith(
        vm.data.policyImportantNotes,
        vm.data.iglImportantNotes,
        vm.data.addonImportantNotes,
        vm.data.defaultExclusions,
        vm.data.optionalExclusions,
        vm.data.fglImportantNotes
      );

      const updatedList = _.chain(lists)
        .map((p) => (_.isNumber(p.id) ? _.extend({}, p, { id: null }) : p))
        .value();

      vm.saving += 1;
      hospitalizationExclusionSvc
        .createOrUpdateServiceExclusions({
          serviceType: vm.serviceType,
          exclusions: updatedList,
          accountOwnerId: vm.accountOwnerId
        })
        .success(() => {
          abp.notify.info(App.localize('SuccessfullySaved'));
          $state.reload();
        })
        .finally(() => {
          vm.saving -= 1;
        });
    }

    // Cancel creation or edit.

    function cancel() {
      if (vm.validateForm() && !vm.isDirty() && !vm.exclusionsForDelete.length) {
        vm.toggleEdit(false);
      } else {
        abp.message.confirm(
          App.localize('UnsavedChangesConfirmation'),
          App.localize('AreYouSure'),
          (d) => {
            if (d) {
              $state.reload();
            }
          }
        );
      }
    }

    function addExclusion(exclusionType) {
      vm.loading += 1;

      const exclusionList = vm.getExclusionList(exclusionType);
      if (exclusionList === null) return;

      const dtNow = new Date().getTime();
      const newId = -Math.abs(dtNow);

      exclusionList.push({
        id: newId,
        clause: '',
        effectiveDate: moment().format(),
        type: exclusionType,
        isNewRecord: true,
        creationTime: moment(),
      });

      // Hack for summernote destroy/reset issue.
      // To retain previous other data and re-initialize the instance upon removing the record.

      resetExclusions(exclusionList);
    }

    function getExclusionList(type) {
      switch (type) {
        case 0:
          return vm.data.defaultExclusions;
        case 1:
          return vm.data.optionalExclusions;
        case 2:
          return vm.data.iglImportantNotes;
        case 3:
          return vm.data.addonImportantNotes;
        case 4:
          return vm.data.policyImportantNotes;
        case 5:
          return vm.data.fglImportantNotes;
        default:
          return null;
      }
    }

    function remove(id, type) {
      if (vm.saving || vm.loading) return;

      vm.loading += 1;

      const exclusionList = vm.getExclusionList(type);
      if (exclusionList === null) return;

      const index = _.findIndex(exclusionList, { id });
      if (index === -1) return;

      $(`#content-${type}-${id}`).summernote('destroy');
      exclusionList.splice(index, 1);

      vm.exclusionsForDelete.push(id);

      // Hack for summernote destroy/reset issue.
      // To retain previous other data and re-initialize the instance upon removing the record.

      resetExclusions(exclusionList);
    }

    function deleteSelectedExclusions(exclusionsForDelete) {
      _.forEach(exclusionsForDelete, (id) => {
        hospitalizationExclusionSvc.deleteExclusions({ ExclusionId: id });
      });
    }

    function resetExclusions(exclusions) {
      // Clone other previous data except the deleted exclusion.

      const clonedItems = _.map(exclusions, (p) => ({
        clonedType: p.type,
        clonedId: p.id,
        clonedClause: p.clause,
      }));

      $timeout(() => {
        _.each(clonedItems, (p) => {
          $(`#content-${p.clonedType}-${p.clonedId}`).summernote('code', p.clonedClause);
        });
        vm.loading -= 1;
      }, 1000);
    }
  }
})();
